export default __webpack_public_path__ + "static/tooltip-interactive-2-do-light-fa09cf7e152148ff96a3446ef8086e087aaf7e13be20e77d9e10cea980de797e.png";